import React from 'react';
import {ListColumnsFactoryComponent, ListConfigNamedColumn, ListProps} from '@src/@types/components/List';
import {ListView} from '@src/components/_views/configurable/ListView';
import OrderListStatusColumn from './OrderListStatusColumn';
import OrderListStatusIndicator from './OrderListStatusIndicator';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {HexColor} from '@src/@types/colors';
import OrderListDeleteItemButton from './OrderListDeleteItemButton';
import OrderListDeadlineAtColumn from './OrderListDeadlineAtColumn';
import OrderProgressColumn from './OrderProgressColumn';
import OrderIndicatorsColumn from './OrderIndicatorsColumn';
import TotalPriceOfList from '@views/orders/TotalPriceOfList';
import OrderListCloneItemButton from '@views/orders/OrderListCloneItemButton';

type Model = IOrderModel & { status_bg_color?: HexColor };
export type OrderListExtendedModel = Model;

export const orderListAdditionalListProps: {
    head?: ListProps<Model>['tableHeadProps'],
    body?: ListProps<Model>['tableBodyProps'],
    context?: ListProps<Model>['listConfigContextOptions'],
    beforeBottomPaginationNode?: ListProps<Model>['renderComponentBeforeTheBottomPagination'],
} = {
    head: {
        cellBeforeColumns: <td className="px-0"/>,
    },
    body: {
        cellBeforeColumnsComponent: OrderListStatusIndicator,
        renderControls(record, rowIndex, onClick, render) {
            if (record?.deleted_at != null) {
                return render();
            }

            return <>
                <OrderListCloneItemButton orderId={record?.id}/>
                <OrderListDeleteItemButton onClick={onClick}/>
            </>;
        }
    },
    context: {
        getCustomColumnComponent(config: ListConfigNamedColumn): ListColumnsFactoryComponent | null {
            switch (config.name) {
                case 'status':
                    return OrderListStatusColumn;
                case 'deadline_at':
                    return OrderListDeadlineAtColumn;
                case 'progress':
                    return OrderProgressColumn;
                case 'indicators':
                    return OrderIndicatorsColumn;
                default:
                    return null;
            }
        },
    },
    beforeBottomPaginationNode: TotalPriceOfList,
};

export class OrdersList<Props extends Record<any, any> = Record<any, any>> extends ListView<Model, Props> {
    protected getPropsForTableHeadComponent(): ListProps['tableHeadProps'] {
        return orderListAdditionalListProps.head;
    }

    protected getPropsForTableBodyComponent(): ListProps['tableBodyProps'] {
        return orderListAdditionalListProps.body;
    }

    protected getListConfigContextOptions(): ListProps['listConfigContextOptions'] {
        return orderListAdditionalListProps.context;
    }

    protected getComponentToRenderBeforeTheBottomPagination(): ListProps<Model>['renderComponentBeforeTheBottomPagination'] {
        return orderListAdditionalListProps.beforeBottomPaginationNode;
    }
}

export default OrdersList.getStoreConnector()(OrdersList);
